import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DriverSpecificDetailsCardComponent } from './driver-specific-details-card.component';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule.forChild()
    ],
    declarations: [DriverSpecificDetailsCardComponent],
    exports: [DriverSpecificDetailsCardComponent]
})
export class DriverSpecificDetailsCardModule {}
